import React from 'react';

const PageHeader = (props) => {
    return (
        <div className="page-header">
            <div className="page-header-content bg_image_header jarallax">
                <div className="container">
                    <h1 className="heading">{props.title}</h1>
                </div>
            </div>
        </div>
    );
};

export default PageHeader;